import { Input } from '@builder.io/sdk';

import { buttonFields } from 'molecules/Button/config';
import imageField from 'molecules/Image/config';

import { authorFields } from 'organisms/Cards/config';

const testimonialCardFields = [
  {
    name: 'variation',
    type: 'string',
    enum: [
      {
        label: 'Quote',
        value: 'quote',
        helperText: 'General quote card with optional company logo.',
      },
      {
        label: 'G2',
        value: 'g2',
        helperText: 'G2 review card with star rating, date, and optional CTA.',
      },
      {
        label: 'Rating Cards',
        value: 'ratingCards',
        helperText: 'Compact rating cards showing 3 reviews simultaneously with stars and dates.',
      },
    ],
    defaultValue: 'quote',
    helperText:
      'Choose the testimonial layout. "Quote" for standard quotes; "G2" for review-style cards; "Rating Cards" for compact multi-card view.',
  },
  {
    name: 'quote',
    type: 'richText',
    defaultValue:
      '<p><strong>Prismatic beautifully supports</strong> the model we wanted: technical support staff configure new instances of known integrations; software engineers get involved when theres something new; support staff can monitor whats happening day-to-day."</p>',
    required: true,
    helperText: 'Main testimonial text. Keep it concise; formatting (bold/links) is supported.',
  },
  imageField('companyLogo', "options.get('variation') === 'quote'"),
  {
    name: 'author',
    type: 'object',
    subFields: authorFields,
    required: true,
    helperText: 'Author details shown under the quote (name, title, and optional headshot).',
  },
  {
    name: 'reviewDate',
    type: 'date',
    defaultValue: 5,
    showIf: "options.get('variation') === 'g2' || options.get('variation') === 'ratingCards'",
    helperText: 'Date of the review. Visible for G2 and Rating Cards variations.',
  },
  {
    name: 'rating',
    type: 'number',
    defaultValue: 5,
    showIf: "options.get('variation') === 'g2' || options.get('variation') === 'ratingCards'",
    helperText: 'Star rating (1–5). Visible for G2 and Rating Cards variations.',
  },
  {
    name: 'button',
    type: 'object',
    subFields: buttonFields,
    showIf: "options.get('variation') === 'g2'",
    helperText: 'Optional CTA button (e.g., "Read the review"). Visible only for the G2 variation.',
  },
] as const satisfies DeepReadonly<Input[]>;

export type TestimonialCardConfigProps = GenerateBuilder<typeof testimonialCardFields>;

export default testimonialCardFields;
